<!--  -->
<template>
<div class="container">
  <div>
    <p>上海三泾庙（以下简称“我司”）深知个人信息对您的重要性，会尽力保护您的个人信息安全。我们致力于维护您对我们的信任，恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、必要性原则、确保安全原则、公开透明原则等。同时，我们承诺依法采取相应的安全保护措施来保护您的个人信息。鉴于此本产品服务提供者(或简称"我们")制定本《隐私保护政策》(下称"本政策/本隐私保护政策")并提醒您:本政策适用于本产品提供的所有产品和服务。</p>
    <p>在使用本产品各项服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用本产品各项服务，即表示您已充分理解并同意本政策。如对本政策内容有任何疑问、意见或建议，您可通过本产品提供的各种联系方式与我们联系。</p>
    <p>本隐私权政策部分将帮助您了解以下内容:</p>
    <p>1、我们如何收集和使用您的个人信息</p>
    <p>2、我们如何共享、转让和公开披露您的个人信息</p>
    <p>3、我们如何存储和保护您的个人信息</p>
    <p>4、我们如何使您拥有管理个人信息的权利</p>
    <p>5、我们如何处理未成年人信息</p>
    <p>6、本政策权如何更新</p>
    <h1>一、我们如何收集和使用您的个人信息</h1>
    <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括姓名、出生日期、身份证件号码、通信通讯联系方式、住址等。其中一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的信息为个人敏感信息，主要包括：身份证件号码、交易信息。</p>
    <h2><b>（一）信息如何收集</b></h2>
    <p>1. 我们通过本平台账户为您提供用户服务。为使用我们的用户服务，您需要创建本平台账户，提供手机号码。我们可能会根据您提供的上述信息校验您的用户身份，确保我们是在为您本人提供服务。</p>
    <p>2. 我们会收集关于您使用我们产品或服务以及使用方式的信息，这些信息包括:</p>
    <p>3. <b>服务日志信息</b>:当您使用我们的客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如搜索查询内容、IP地址、浏览器的类型、使用的语言、访问日期和时间及您访问的网页记录等。</p>
    <p>4. 请您理解，单独的日志信息等是无法识别特定自然人身份的信息。除非将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，那么在结合使用期间，这类非个人信息将被视为个人信息，我们会将该类个人信息做匿名化、去标识化处理(取得您的授权或法律法规另有规定的情况除外)。</p>
    <p>5. 当您在本产品中使用第三方提供的服务时，第三方可能会获取您的位置、姓名、证件类型、身份证件号码、手机号码信息，在经过您的明示同意后，第三方可获取您的以上信息；对于您在使用第三方提供的服务时主动提供给第三方的相关信息，我们将视为您允许该第三方获取上述此类信息；对于您在使用该第三方服务时产生的信息，应由您与该第三方依法约定上述信息的收集和使用事项。如您拒绝第三方在提供服务时收集、使用或者传递上述信息，将可能会导致您无法在本产品中使用第三方的相应服务，但这不影响您使用本产品的其他功能。</p>
    <p>当您与我们联系时，为验证您的身份，帮助您解决问题，我们可能会记录您与我们的对话并收集其他为解决问题所需的必要信息。</p>
    <h2><b>（二）信息如何使用</b></h2>
    <p>1. 在向您提供我们的本产品服务，并为改进这些产品或服务时使用。</p>
    <p>2. 在我们向您提供本产品相关服务期间，您授权我们持续收集和使用您的信息。在您注销服务时，我们将停止收集您相关的个人信息，但我们会在业务资料归档、审计、监管协查等领域继续使用此前收集的您的相关个人信息。</p>
    <p>3. 为提升您的产品或服务体验，或为防范风险，我们会对服务使用情况进行汇总、统计分析、加工，但这些信息不会包含您的任何身份识别信息。</p>
    <p>4. 您授权同意的，以及于法律允许的其它用途。</p>
    <!-- 继续添加完整的隐私政策内容 -->
  </div>
</div>

</template>

<script>
export default {
  data() {
    return {
      showPolicy: false
    };
  },
  methods: {
    togglePolicy() {
      this.showPolicy = !this.showPolicy;
    }
  }
};
</script>

<style scoped>
p{
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    unicode-bidi: isolate;
}
h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}
h1 {
    display: block;
    font-size: 2em;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}
.container {
    width: 90%;
    margin: 20px auto;
    overflow-x: hidden;
    min-height: 100vh;
    background: #fff;
}
</style>
